module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.72eea25a.woff2";